import type { EmotionCache } from '@emotion/cache';
import createCache from '@emotion/cache';

// Setting key to 'css' ensures both SSR and client generate identical class prefixes which fixes the issue with hydration mismatch
export const createEmotionCache = (): EmotionCache =>
  createCache({ key: 'css', prepend: true });

// keep one persistent instance for the client
export const clientEmotionCache = createEmotionCache();
